import { AdjustableHeights, CreatorAccessory, PostType } from '@/types/creator';
import { UUID } from '@/types/types';

export enum UserDataObjectType {
	ORIGIN_POINT = 'origin_point',
	HANDLE = 'handle',
	MEASUREMENT_POINT = 'measurement_point',
	UPPER_POST = 'upper_post',
	LOWER_POST = 'lower_post',
	MIDDLE_POST = 'middle_post',
	MIDDLE_SEGMENT = 'middle_segment',
	UPPER_SEGMENT = 'upper_segment',
	LOWER_SEGMENT = 'lower_segment',
	UPPER_ENDING = 'upper_ending',
	LOWER_ENDING = 'lower_ending',
	LOWER_ENDING_ADJUSTABLE = 'lower_ending_adjustable',
	UPPER_ENDING_ADJUSTABLE = 'upper_ending_adjustable',
}

export enum UserDataProp {
	OBJECT_TYPE = 'object_type',
	TARGET = 'target',
	POST_ID = 'post_id',
	REVERT_SCALE = 'revert_scale',
	HIDDEN = 'hidden',
	VARIANT_NAME = 'variant_name',
	OBJECTS_AVAILABLE_SPACE = 'objects_available_space',
	SLOT_NAME = 'slot_name',
	MEASUREMENT_ID = 'measurement_id',
	MEASUREMENT_LABEL = 'measurement_label',
	MEASUREMENT_OFFSET_AXIS = 'measurement_offset_axis',
	MEASUREMENT_POINT_POSITION = 'measurement_point_position',
	MEASUREMENT_OFFSET_LABEL = 'measurement_offset_label',
	MEASUREMENT_LABEL_ROTATION = 'measurement_label_rotation',
	MEASUREMENT_OFFSET_LENGTH = 'measurement_offset_length',
}

export enum CustomObjectName {
	HANDLE_SLOT = 'handle_slot',
}

export enum ThreeEvent {
	DISTANCE = 'distance',
	SET_ADJUSTABLE_HEIGHTS = 'set_adjustable_heights',
	UPDATE_OBJECT_POS_Y = 'update_object_pos_y',
	UPDATE_OBJECTS_POS_Y = 'update_objects_pos_y',
	ADD_POST = 'add_post',
	DETECTED_COLLISION = 'detected_collision',
}

export enum MeasurementPointPosition {
	START,
	END,
}

export enum MeasurementOffsetAxis {
	X,
	Y,
	Z,
}

export type MeasurementOffsetLabel = [number, number, number];

export type ThreeEvents = {
	[ThreeEvent.DISTANCE]: number;
	[ThreeEvent.SET_ADJUSTABLE_HEIGHTS]: Partial<AdjustableHeights>;
	[ThreeEvent.UPDATE_OBJECT_POS_Y]: { id: UUID; posY: number };
	[ThreeEvent.UPDATE_OBJECTS_POS_Y]: { id: UUID; posY: number }[];
	[ThreeEvent.ADD_POST]: {
		type: Exclude<PostType, PostType.MIDDLE>;
		posY: number;
	};
	[ThreeEvent.DETECTED_COLLISION]: boolean;
};

export type SerializedHandleManager = {
	originToYCenterConst: number;
	originalHeights: AdjustableHeights;
	adjustableHeights: AdjustableHeights;
	modelPath: string;
};

export interface SerializedCollidableObject {
	id: UUID;
	posY: number;
}

export interface SerializedPost extends SerializedCollidableObject {
	type: PostType;
	linkedCreatorAccessoryId: UUID | null;
	isAdjustable: boolean;
}

export interface SerializedAccessory extends SerializedCollidableObject {
	mountingSide: CreatorAccessory['mountingSide'];
}

export type SerializedObjectsManager = {
	posts: SerializedPost[];
	accessories: SerializedAccessory[];
};

export type SerializedRenderer = {
	handleManager: SerializedHandleManager;
	objectsManager: SerializedObjectsManager;
};
